import { jwtDecode } from 'jwt-decode';

interface JwtExpPayload {
  exp?: number;
}

/** Returns epoch milliseconds when the JWT expires, if present. */
export function getJwtExpiryMs(token: string): number | null {
  try {
    const decoded = jwtDecode<JwtExpPayload>(token);
    if (typeof decoded.exp !== 'number') {
      return null;
    }
    return decoded.exp * 1000;
  } catch {
    return null;
  }
}

export function isJwtExpired(token: string | null, skewMs = 5000): boolean {
  if (!token) {
    return true;
  }
  const expMs = getJwtExpiryMs(token);
  if (expMs === null) {
    return false;
  }
  return Date.now() >= expMs - skewMs;
}
